/**
 * Main App Component
 * 
 * This is the root component of the application that sets up the routing and
 * provides all the necessary context providers to the component tree.
 */
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { WishlistProvider } from './contexts/WishlistContext';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContainer } from 'react-toastify';
import AppRoutes from './AppRoutes';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

/**
 * App component that wraps the entire application with necessary providers
 * Sets up the component hierarchy with all required contexts:
 * - Router: For navigation and routing
 * - AuthProvider: For user authentication
 * - CartProvider: For shopping cart functionality
 * - WishlistProvider: For wishlist functionality
 * - ToastProvider: For toast notifications
 */
function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
            <ToastProvider>
              <div className="app">
                <ToastContainer position="top-right" autoClose={3000} />
                <AppRoutes />
              </div>
            </ToastProvider>
          </WishlistProvider>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;